import { defineStore } from "pinia";
import { ref } from "vue";

export const useApmTraceStore = defineStore("apmTrace", () => {
    const traceId = ref("");

    const setTraceId = (newTraceId: string) => {
        traceId.value = newTraceId;
    };

    return {
        traceId,
        setTraceId,
    };
});
